import { Select } from "antd";
import React, { useContext } from "react";
import { TimeTrackingUserDataContext } from "../../../TimeTrackingUserDataProvider";
import { TrackerContext } from "../utils/types";

const ROW_HEIGHT = 46;

export const ProjectSelect: React.FC = () => {
  const {
    formData,
    setFormData,
    isTracking,
    updateCurrentSessionProject,
    trackerLoading,
  } = useContext(TrackerContext);
  const { projects } = useContext(TimeTrackingUserDataContext);

  const handleChange = (value: string) => {
    if (isTracking) {
      updateCurrentSessionProject(value);
    } else {
      setFormData((prev) => ({ ...prev, projectId: value }));
    }
  };

  return (
    <div style={{ borderRight: "1px solid #d9d9d9", padding: "0 12px" }}>
      <Select
        style={{
          width: 200,
        }}
        value={formData.projectId || undefined}
        placeholder="+ Project"
        disabled={trackerLoading && isTracking}
        onChange={handleChange}
        dropdownMatchSelectWidth={false}
        optionLabelProp="label"
      >
        {projects.map((p) => (
          <Select.Option
            key={p.projectId}
            value={p.projectId}
            label={
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 6,
                  lineHeight: `${ROW_HEIGHT}px`,
                  height: "100%",
                }}
              >
                <span
                  style={{
                    width: 11,
                    height: 11,
                    borderRadius: "50%",
                    backgroundColor: p.color,
                    display: "inline-block",
                    flexShrink: 0,
                  }}
                />
                {p.projectName}
              </span>
            }
          >
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span
                style={{
                  width: 11,
                  height: 11,
                  borderRadius: "50%",
                  backgroundColor: p.color,
                  display: "inline-block",
                  flexShrink: 0,
                }}
              />
              {p.projectName}
            </span>
          </Select.Option>
        ))}
      </Select>
    </div>
  );
};
